// tools and component for date picker
import dayjs from 'dayjs';

// API fetch
import axios from "axios";
import { baseURL } from '../config/api-config.js';

export async function getHoraires(jour,idSpot){ //jour : date as string
  jour = new Date(jour); //convert as date object
  let nbJour = getDayOfYear(jour); //function called to calculate the number of the day (1 to 366)

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/horaires/detail/${idSpot}/${nbJour}`,
    });
    const horaires = response.data.data;
    return horaires;
  } catch (err) {
    return null;
  }
}



// calculate the number of the day
// param : selected day in datepicker 
export function getDayOfYear(date) { 
    const timestamp1 = Date.UTC( //convert selected day as timeStamp (milliseconds from 1/1/1970)
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    const timestamp2 = Date.UTC(date.getFullYear(), 0, 0); //convert 1 day of the year (same as selected day) as timeStamp (milliseconds from 1/1/1970)
  
    const differenceInMilliseconds = timestamp1 - timestamp2; // calculate diff
  
    let differenceInDays = differenceInMilliseconds / 1000 / 60 / 60 / 24; // diff in days
  
    if (!leapyear(date.getFullYear()) && differenceInDays >= 60) { // on leap year  if selected day is after 1 march : 
      differenceInDays += 1; //we add 1 day
    }
  
    return differenceInDays; // return the number of the day (usefull to find the correct opening hours)
  }
  
  function leapyear(year) { // is this 'year' a leap year (bisextil)
    return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
  }


  //transformer heure decimal en H 60minutes
  export function heureDecimalConverter(heureDecimal){

    return Math.floor(heureDecimal)+":"+getMinutesTime(heureDecimal)

  }

  export function getMinutesTime(heure) {
    let minutes = 0;
    minutes = String((heure - Math.floor(heure)) * 60);
    if (minutes.length < 2) { minutes += "0"; }
    return minutes;
}

export function prepareDatesInfos(period,mode){

  let dates="";

  if (mode===0) // sur une seul ligne
  {
     dates += "du " + dayjs(period[0][0]).format("DD/MM/YYYY");
    dates += " à " + heureDecimalConverter(period[1][0]);
    dates += " au " + dayjs(period[0][1]).format("DD/MM/YYYY");
    dates += " à " + heureDecimalConverter(period[1][1]);
  }
  if (mode===1) // ligne 1/2
  {
    //prepare dates infos
    dates += "du " + dayjs(period[0][0]).format("DD/MM/YYYY");
    dates += " à " + heureDecimalConverter(period[1][0]);

  }

  if (mode===2) // ligne 2/2
  {
    dates += " au " + dayjs(period[0][1]).format("DD/MM/YYYY");
    dates += " à " + heureDecimalConverter(period[1][1]);
  }

    return dates
}